import React from 'react';

import Data from 'data';
import Locale, { genderString, genderPair } from 'data/locale';
import Store from 'store';
import { colored } from './builder';

const _L = Locale("bnet-tooltips.js");

const useClass = () => Store.useProfile(profile => profile.class);

function LegendaryEffects({ gem, level }) {
  const charClass = useClass();

  const value = gem.effects[0].value.map((v, i) => v + level * gem.effects[0].delta[i]);
  const effect1 = Data.formatBonus(charClass, gem.effects[0].format || Data.stats[gem.effects[0].stat].format, value, 2, gem.effects[0].stat);
  const effect2 = Data.formatBonus(charClass, gem.effects[1].format || Data.stats[gem.effects[1].stat].format, gem.effects[1].value || [], level < 25 ? 1 : 2, gem.effects[1].stat);
  return (
    <ul className="item-effects">
      <li className="d3-color-orange d3-item-property-default"><p>{effect1}</p></li>
      <li className={`d3-color-${level < 25 ? "gray" : "orange"} d3-item-property-default`}>
        <p>
          {effect2}{level < 25 && " "}{level < 25 && colored(_L`(Requires Rank ${25})`, "red")}
        </p>
      </li>
    </ul>
  );
}

function GemEffects({ reg, quality, socketType }) {
  const charClass = useClass();

  function fmtSlot(data, flag) {
    const fmt = Data.formatBonus(charClass, Data.stats[data.stat].format, [data.amount[quality]]);
    return <span className={flag ? null : "d3-color-gray"}>{fmt}</span>;
  }
  return (
    <ul className="item-effects">
      <li className="d3-color-white">{_L`Can be inserted into equipment with sockets.`}</li>
      <li className="gem-effect"><span className="d3-color-gray">{_L`Helm:`}</span> {fmtSlot(reg.head, !socketType || socketType === "head")}</li>
      <li className="gem-effect"><span className="d3-color-gray">{_L`Weapon:`}</span> {fmtSlot(reg.weapon, !socketType || socketType === "weapon")}</li>
      <li className="gem-effect"><span className="d3-color-gray">{_L`Other:`}</span> {fmtSlot(reg.other, socketType !== "head" && socketType !== "weapon")}</li>
    </ul>
  );
}

export default React.memo(function GemTooltip({ id, level, socketType }) {
  const gem = (id instanceof Array ? undefined : Data.legendaryGems[id]);
  const reg = (id instanceof Array ? Data.gemColors[id[1]] : undefined);
  if (!gem && !reg) {
    return null;
  }

  level = (level || 0);

  const icon = Data.getItemIcon(id);
  const quality = (gem ? "orange" : "blue");

  return (
    <div className="d3-tooltip d3-tooltip-item">
      <div className={`tooltip-head tooltip-head-${quality}`}>
        <h3 className={`d3-color-${quality}`}>{gem ? gem.name : reg.names[id[0]]}</h3>
      </div>
      <div className="tooltip-body">
        <span className={`d3-icon d3-icon-item d3-icon-item-large d3-icon-item-${quality}`}>
          <span className="icon-item-gradient">
            <span className="icon-item-inner icon-item-square" style={{backgroundImage: `url(${icon})`}}/>
          </span>
        </span>
        <div className="d3-item-properties">
          {!!(gem && level) && <ul className="item-type-right"><li className="item-jewel-rank">{_L`Rank ${level}`}</li></ul>}
          {!!gem && <ul className="item-type"><li><span className="d3-color-orange">{genderPair(Data.qualities.legendary.prefix, _L`Gem`)}</span></li></ul>}
          {!!gem && <div className="item-description d3-color-white"><p></p></div>}
          {!gem && <ul className="item-type"><li><span className="d3-color-default">{genderString(_L`Gem`)}</span></li></ul>}

          <div className="item-before-effects"/>

          {gem ? <LegendaryEffects gem={gem} level={level}/> : <GemEffects reg={reg} quality={id[0]} socketType={socketType}/>}

          <ul className="item-extras">
            <li>{_L`Account Bound`}</li>
          </ul>
          {!!gem && <span className="item-unique-equipped">{_L`Unique Equipped`}</span>}
          <span className="clear"/>
        </div>
      </div>
      {!!(gem && gem.flavor) && <div className="tooltip-extension"><div className="flavor">{gem.flavor}</div></div>}
    </div>
  );
});
